/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        24/01/2020      1973: Related Symptoms Implementation
*********************************************************************************/
const steps = [

    { name: 'emergency-question' },
    { name: 'start' },
    { name: 'confirm' },  
    { name: 'location', previous: 'confirm' },
    { name: 'emergency', previous: 'emergency-question' },
    { name: 'symptom-priority' },
    { name: 'related-symptoms', previous: 'symptom-priority' },//CHID1
    { name: 'questions', previous: 'symptom-priority' },
    { name: 'covid', previous: 'symptom-priority' },
    { name: 'care-options', previous: 'symptom-priority' },
    { name: 'care-options', previous: 'symptom-priority' },
    { name: 'care-options-result' },
    { name: 'send-information' },
    { name: 'house-visit', previous: 'care-options' },
    { name: 'house-visit-confirm-screen' },
    { name: 'telemedicine', previous: 'care-options' },
    { name: 'telemed-connectiontype',previous: 'care-options' },
    { name: 'telemed-videoprompt' },
    { name: 'telemed-pharma-prompt',previous:'telemedicine-info' },
    { name: 'telemed-confirm-screen' },
    { name: 'telemedicine-info',previous:'telemed-videoprompt' },
    { name: 'telemedicine-result' },
    { name: 'telemedicine-result' },
    { name: 'concierge-care', previous: 'care-options' },
    { name: 'concierge-confirm-screen' },
    { name: 'concierge-care-result' },
]

export default steps
